module.exports = __webpack_public_path__ + "img/ep-ours.e044836d.jpg";